export enum JsonApiType {
  CARD = 'cards',
  CARD_TYPE = 'card-types',
}
